import { render } from "./SenderList.vue?vue&type=template&id=64de3521"
import script from "./SenderList.vue?vue&type=script&lang=js"
export * from "./SenderList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__